module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-loading-fade"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-loading-mask",
    class: [_vm.customClass, {
      'is-fullscreen': _vm.fullscreen
    }]
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "el-loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c9c3ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/src/loading.vue
// module id = 1402
// module chunks = 107